// extracted by mini-css-extract-plugin
export var container = "_nw-0";
export var dotAnimation = "_nw-2";
export var dotsLoading = "_nw-1";